import { render } from "./infoOfContact.vue?vue&type=template&id=1d7f9bdb"
import script from "./infoOfContact.vue?vue&type=script&lang=js"
export * from "./infoOfContact.vue?vue&type=script&lang=js"

import "./infoOfContact.vue?vue&type=style&index=0&id=1d7f9bdb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__